import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import '@emran-alhaddad/saudi-riyal-font/index.css';

const ManageServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No token found. Access denied.");
          setLoading(false);
          return;
        }

        const response = await axios.get("https://demo-two.keytime.sa/api/services", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setServices(response.data);
      } catch (error) {
        setError("Failed to fetch services.");
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const deleteService = async (service_id) => {

    if (!service_id) {
      console.error("🚨 Cannot delete: Service ID is undefined!");
      setError("Service ID is missing. Unable to delete.");
      return;
    }
  
    console.log(`📡 Deleting service with ID: ${service_id}`);
  
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("No token found. Access denied.");
        return;
      }
  
      await axios.delete(`https://demo-two.keytime.sa/api/services/${service_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setServices((prevServices) =>
        prevServices.filter((service) => service.service_id !== service_id)
      );
    } catch (error) {
      setError("Failed to delete service.");
      console.error("Error deleting service:", error);
    }
  };
  
  const editService = (service) => {
    if (!service || !service.service_id) {
      console.error("🚨 Cannot edit: Service data is incomplete!");
      setError("Invalid service data. Unable to edit.");
      return;
    }
  
    console.log(`📡 Editing service with ID: ${service.service_id}`);
    navigate("/dashboard/addservice", { state: { service } });
  };
  

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="w-[80%] flex flex-col justify-center items-center mx-auto gap-10">
      <h2 className="text-2xl py-5">Manage Services</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service) => (
          <div key={service._id} className="border p-4 rounded-lg shadow-md">
            <div className="flex flex-col items-center">
              <img
                src={`/serviceImages/${service.thumbnail}`}
                alt="Service"
                className="w-32 h-32 object-cover rounded"
              />
              <div className="mt-3 text-center">
                <h3 className="text-lg font-semibold">{service.name}</h3>
                <p className="text-gray-600">{service.description}</p>
                <p className="text-sm text-gray-800 font-bold icon-saudi_riyal" >
                   {service.price}
                </p>
                <div className="flex gap-3 mt-3">
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded"
                    onClick={() => deleteService(service.service_id)}
                  >
                    Delete
                  </button>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded"
                    onClick={() => editService(service)}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageServices;
